import React, { Component } from 'react';
import fp from 'lodash/fp';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { LIST_FILTER_SHORT_MAX_LENGTH } from '../../../../../../common/constants';

import Checkbox from '../../../../../../common/checkbox/Checkbox';
import Radio from '../../../../../../common/radio/Radio';
import filterDefinitionPropType from '../../../../filterDefinitionPropType';
import defaultStyles from './ListPillModal.module.scss';

class ListPillModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            search: ''
        };

        this.isLongList = () => this.props.filterDefinition.availableValues
            && this.props.filterDefinition.availableValues.reduce(
                (acc, cur) => (cur.children ? acc + cur.children.length : acc + 1), 0
            ) > LIST_FILTER_SHORT_MAX_LENGTH;

        this.updateSearch = this.updateSearch.bind(this);
        this.renderSelectableItem = this.renderSelectableItem.bind(this);
    }

    // eslint-disable-next-line
    calculateValue(formState) {
        return Object.entries(formState).filter((x) => x[1]).map((x) => x[0]);
    }

    // eslint-disable-next-line
    calculateValueIsBlank(formState) {
        return this.calculateValue(formState).length === 0;
    }

    componentDidMount() {
        if (!this.props.filterDefinition
            || !this.props.filterDefinition.availableValues
            || !this.props.filterDefinition.availableValues.length) {
            this.props.getAvailableListValues();
        }

        const form = this.props.value.reduce(
            (acc, cur) => ({

                ...acc,
                [cur]: true
            }),
            {}
        );
        this.props.setUpState(
            this.calculateValue(form),
            form,
            !Array.isArray(this.props.value) || this.props.value.length === 0
        );
    }

    componentWillUnmount() {
        this.props.resetFilter();
    }

    getEmptyValues() {
        return {
            value: this.calculateValue([]),
            form: {}
        };
    }

    updateSearch(event) {
        this.setState({ search: event.target.value });
    }

    renderSelectableItem(a) {
        const { styles } = this.props;
        return (
            <div key={ a.value || a } className={ styles.listModalRow }>
                <div className={ styles.listRowLabel }>
                    { a.title || a.name || a }
                </div>
                <div className={ styles.listRowCheckbox }>
                    { this.props.filterDefinition.radio ? (
                        <Radio
                            checked={ this.props.value.includes(a.value || a) }
                            onClick={
                                (checked) => this.props
                                    .setForm({ [a.value || a]: checked })
                            }
                        />
                    ) : (
                        <Checkbox
                            checked={ this.props.value.includes(a.value || a) }
                            onChange={ (checked) => this
                                .props.handleUpdate(a.value || a, checked) }
                            disabled={ a.disabled }
                        />
                    ) }
                </div>
            </div>
        );
    }

    renderNormalList() {
        const { styles } = this.props;
        if (!this.props.filterDefinition
            || !this.props.filterDefinition.availableValues
            || !this.props.filterDefinition.availableValues.length) return null;

        let renderedValues = this.state.search
            ? this.props.filterDefinition.availableValues.reduce((acc, cur) => {
                if (cur.children) {
                    return [...acc, {
                        ...cur,
                        children: cur.children.filter(
                            (f) => f.value.toLowerCase().includes(this.state.search.toLowerCase())
                        )
                    }];
                }

                return cur.value.toLowerCase().includes(this.state.search.toLowerCase()) ? [...acc, cur] : acc;
            }, [])
            : this.props.filterDefinition.availableValues;

        if (fp.get('props.filterDefinition.customSort')(this)) {
            renderedValues = renderedValues.map((v) => ({
                ...v,
                checked: this.props.value.includes(v.value),
                children: v.children
                    ? v.children
                        .map((c) => fp.set('checked', this.props.value.includes(c.value))(c))
                        .sort(this.props.filterDefinition.customSort)
                    : undefined
            }))
                .sort(this.props.filterDefinition.customSort);
        }

        return (
            <div>
                { this.isLongList() && (
                    <div className={ styles.filterSearcher }>
                        <input onChange={ this.updateSearch } placeholder="Search" />
                    </div>
                ) }
                <div className={
                    this.isLongList() ? styles.long : styles.short
                }
                >
                    { renderedValues.map((a) => (a.children
                        ? (
                            <div key={ a.title || a }>
                                <div className={ styles.listGroupItem }>
                                    { a.title }
                                </div>
                                <div>
                                    { a.children.map(this.renderSelectableItem) }
                                </div>
                            </div>
                        )
                        : this.renderSelectableItem(a)
                    )) }
                </div>
            </div>
        );
    }

    renderAddFilterList() {
        const { styles } = this.props;
        return (
            <div className={ styles.addFilter }>
                { this.props.filterDefinition
                    ? this.props.filterDefinition.availableValues.map((a) => (
                        <div key={ a } className={ styles.listModalRow } filtername={ a }>
                            <div
                                className={ classnames({
                                    [styles.listRowLabel]: true,
                                    [styles.listRowLabelDisabled]:
                                        this.props.currentFilters.find((c) => c.title === a)
                                }) }
                            >
                                { a }
                            </div>
                            <button
                                type="button"
                                className={ styles.listRowAdd }
                                onClick={ () => { this.props.handleAdd(a); } }
                                disabled={ this.props.currentFilters.find((c) => c.title === a) }
                            >
                                +
                            </button>
                        </div>
                    )) : null }
            </div>
        );
    }

    render() {
        return this.props.isAddFilter
            ? this.renderAddFilterList()
            : this.renderNormalList();
    }
}

ListPillModal.propTypes = {
    isAddFilter: PropTypes.bool,
    handleAdd: PropTypes.func,
    filter: PropTypes.shape({
        type: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
        radio: PropTypes.bool,
        value: PropTypes.arrayOf(PropTypes.string)
    }),
    value: PropTypes.arrayOf(PropTypes.string),
    handleUpdate: PropTypes.func.isRequired,
    setForm: PropTypes.func.isRequired,
    setUpState: PropTypes.func.isRequired,
    resetFilter: PropTypes.func.isRequired,
    getAvailableListValues: PropTypes.func.isRequired,
    currentFilters: PropTypes.arrayOf(PropTypes.shape({})),
    filterDefinition: filterDefinitionPropType,
    styles: PropTypes.objectOf(PropTypes.string)
};

ListPillModal.defaultProps = {
    isAddFilter: false,
    handleAdd: null,
    filter: {
        value: [],
        radio: false
    },
    value: [],
    currentFilters: [],
    filterDefinition: null,
    styles: defaultStyles
};

export default ListPillModal;
